// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"6eb01557","453":"323265d9","732":"4bca3037"}[chunkId] + ".chunk.js";
};